import { render } from "./DesignerToolbar.vue?vue&type=template&id=1417f651&ts=true"
import script from "./DesignerToolbar.vue?vue&type=script&lang=ts"
export * from "./DesignerToolbar.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__